module.exports = __webpack_public_path__ + "static/media/clientSix.7a24d236.webp";